import { FormControl, Grid, InputLabel, MenuItem, Paper, Select, Typography } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { FilterList } from '@mui/icons-material';
import { DATE_RANGE_OPTIONS, SUBSCRIPTION_OPTIONS } from './dqUtils';

const DqFilters = ({
  dateRange,
  startDate,
  endDate,
  subscription,
  onDateRangeChange,
  onStartDateChange,
  onEndDateChange,
  onSubscriptionChange,
}) => (
  <Paper sx={{ p: 2, mb: 0, mt: 2, width: '100%' }}>
    <Grid container spacing={1} alignItems="center" justifyContent="center">
      <Typography variant="h6" sx={{ mr: 1 }}>
        <FilterList fontSize="small" sx={{ mr: 1, verticalAlign: 'middle' }} />
        Filters
      </Typography>
      <Grid item xs={12} md={3}>
        <FormControl fullWidth size="small">
          <InputLabel>Date Range</InputLabel>
          <Select
            value={dateRange}
            label="Date Range"
            onChange={(e) => onDateRangeChange(e.target.value)}
          >
            {DATE_RANGE_OPTIONS.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} md={3}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label="Start Date"
            value={startDate}
            onChange={onStartDateChange}
            slotProps={{ textField: { size: 'small', fullWidth: true } }}
          />
        </LocalizationProvider>
      </Grid>
      <Grid item xs={12} md={3}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label="End Date"
            value={endDate}
            onChange={onEndDateChange}
            slotProps={{ textField: { size: 'small', fullWidth: true } }}
          />
        </LocalizationProvider>
      </Grid>
      <Grid item xs={12} md={3}>
        <FormControl fullWidth size="small">
          <InputLabel>Subscription</InputLabel>
          <Select
            value={subscription}
            label="Subscription"
            onChange={(e) => onSubscriptionChange(e.target.value)}
          >
            {SUBSCRIPTION_OPTIONS.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  </Paper>
);

export default DqFilters;
